import { render, staticRenderFns } from "./EditableTab.vue?vue&type=template&id=17ff8da0&scoped=true&lang=pug&"
import script from "./EditableTab.vue?vue&type=script&lang=js&"
export * from "./EditableTab.vue?vue&type=script&lang=js&"
import style0 from "./EditableTab.vue?vue&type=style&index=0&id=17ff8da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ff8da0",
  null
  
)

export default component.exports